export enum ROUTES {
  HOME = '/',
  THERAPISTS = '/book/therapists',
  THERAPIST_PROFILE = '/book/therapists/profile/[id]',
  BOOKING = '/book/booking',
  CONFIRMATION = '/book/confirmation'
}
